import { render, staticRenderFns } from "./addGrid.vue?vue&type=template&id=8aa0c262"
import script from "./addGrid.vue?vue&type=script&lang=js"
export * from "./addGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports